import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Modal } from "antd";
import {
    Row,
    Form,
    Input,
    Col,
    Select,
    Collapse,
    notification,
    Popconfirm,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import {
    MinusCircleTwoTone,
    PlusCircleTwoTone,
    DeleteOutlined,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import AreasApi from "../../common/Apis/AreasApi";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const CleaningTraceabilityAreas = () => {
    let navigate = useNavigate();
    const { Content } = Layout;
    const { Panel } = Collapse;
    const [areas, setAreas] = React.useState([]);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    const [PaginatePage, setPaginatePage] = useState(0);
    const [PaginatetotalPages, settotalPages] = useState(0);
    const [PaginateLimit, setPaginateLimit] = useState(10);
    const [formPaginate] = Form.useForm();
    const [FilterEnable, setFilterEnable] = useState(true);
    const [totalElements, setTotalElements] = useState(0);

    // State for modal
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingArea, setEditingArea] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    formPaginate.setFieldsValue({
        paginate: PaginateLimit,
    });

    const handlesetPaginateLimit = (value) => {
        setPaginateLimit(value);
        setCurrentPage(1);
        formPaginate.setFieldsValue({
            paginate: value,
        });
        AreasApi.ListAreas(0, value)
            .then((response) => {
                settotalPages(response.totalPages || 0);
                setAreas(response.payloadDto || []);
                setTotalElements(response.totalElements);

            })
            .catch((err) => {
                console.log(err);
            });
    };
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (page) => {
    if (page < 1 || page > PaginatetotalPages) return;
    setCurrentPage(page);
    let pageNew = page - 1;
    AreasApi.ListAreas(pageNew, PaginateLimit)
        .then((response) => {
            setPaginatePage(pageNew);
            settotalPages(response.totalPages || 0);
            setAreas(response.payloadDto || []);
            setTotalElements(response.totalElements);

        })
        .catch((err) => {
            console.log(err);
        });
};

    const getAreas = useCallback(() => {
        AreasApi.ListAreas(PaginatePage, PaginateLimit)
            .then((response) => {
                settotalPages(response.totalPages || 0);
                setAreas(response.payloadDto?.sort((a, b) => b.id - a.id) || []);
                setTotalElements(response.totalElements);

            })
            .catch((err) => {
                console.log(err);
            });
    }, [PaginatePage, PaginateLimit]);

    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);

    // Fetch departments on component mount
    const getDepartments = useCallback(() => {
        DepartmentsApi.ListDepartments(0, 100) // Adjust limit as needed
            .then((response) => {
                console.log("Fetched departments:", response);
                setDepartments(response.payloadDto || []);
            })
            .catch((err) => {
                console.log(err);
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Error</span>,
                    description: "Failed to fetch departments",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#fff2f0",
                        color: "red",
                    },
                });
            });
    }, []);

    useEffect(() => {
        getAreas();
        PageLoading();
        getDepartments(); // Fetch departments when component mounts
    }, [getAreas, PageLoading, getDepartments]);

    const handleDeleteArea = (areaId) => {
        AreasApi.DeleteArea(areaId)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
                    description: "Area deleted successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                PageLoading();
                getAreas();
            })
            .catch((err) => {
                if (err.apiError?.status) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Error</span>,
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };

    const handleRemovefilterTraceability = (FiltergetTraceabilityIndex) => {
        const newfilterTraceability = [...filterTraceabilityItem];
        newfilterTraceability.splice(FiltergetTraceabilityIndex, 1);
        setFilterTraceability(newfilterTraceability);
        if (FiltergetTraceabilityIndex == 0) {
            getAreas();
        }
    };

    const handleClear = () => {
    setFilterTraceability([{ title: "", answerType: "", name: "" }]);
    AreasApi.ListAreas(0, PaginateLimit)
        .then((response) => {
            setCurrentPage(1);
            setPaginatePage(0);
            settotalPages(response.totalPages || 0);
            setTotalElements(response.totalElements || 0);
            setAreas(response.payloadDto || []);
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
            }, 800);
        })
        .catch((err) => {
            console.log(err);
            setIsLoading(false);
        });
};

    const formRef = useRef(null);

    const [filterTraceabilityItem, setFilterTraceability] = useState([
        {
            title: "",
            answerType: "",
            name: "",
        },
    ]);

    const handleAddfilterTraceability = () => {
        setFilterTraceability([
            ...filterTraceabilityItem,
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };

    const handleSubmit = (data) => {
        setIsLoading(true);
        setFilterEnable(false);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        let singleLineString = filterTraceabilityItem
            .map((obj) => {
                if (obj.answerType === "%") {
                    return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                } else if (obj.answerType === "=") {
                    return `${obj.title}${obj.answerType}${obj.name}`;
                } else {
                    return `${obj.title}=${obj.name}`;
                }
            })
            .join("&");

        let filderData = window.btoa("componentCode=CLEANING_TRACEABILITY_ITEM&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
        QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
            .then((response) => {
                setCurrentPage(1);
                setPaginatePage(0);
                settotalPages(response.totalPages || 0);
                setAreas(response.payloadDto || []);
                setIsLoading(false);
            })
            .catch((err) => {  
            console.log(err);
            setIsLoading(false);
        });
    };

    const handleChangeTitle = (FiltergetTraceabilityItemIndex, value) => {
        const newfilterTraceability = [...filterTraceabilityItem];
        newfilterTraceability[FiltergetTraceabilityItemIndex].title = value;
        setFilterTraceability(newfilterTraceability);
    };

    const handleChangeAnswertype = (FiltergetTraceabilityItemIndex, value) => {
        const newfilterTraceability = [...filterTraceabilityItem];
        newfilterTraceability[FiltergetTraceabilityItemIndex].answerType = value;
        setFilterTraceability(newfilterTraceability);
    };

    const handleChangename = (FiltergetTraceabilityItemIndex, value) => {
        const newfilterTraceability = [...filterTraceabilityItem];
        newfilterTraceability[FiltergetTraceabilityItemIndex].name = value;
        setFilterTraceability(newfilterTraceability);
    };

    // Modal handlers
    const handleOpenAddModal = () => {
        setIsEditMode(false);
        setEditingArea(null);
        form.resetFields(); // Reset form fields
        setIsModalVisible(true);
    };

    const handleOpenEditModal = (area) => {
        setIsEditMode(true);
        setEditingArea(area);
        form.setFieldsValue({
            departmentId: area?.institutionDTO?.id,
            areaName: area?.areaName
        });
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setIsEditMode(false);
        setEditingArea(null);
        form.resetFields();
    };

    const handleAddArea = async (values) => {
        setLoading(true);
        try {
            // Log the values to see what we're getting from the form
            console.log("Form values:", values);

            // Ensure we have all required IDs
            const institutionId = values.departmentId; // Department ID
            const tenantId = decodedToken?.tenantId;

            // Validate required fields
            if (!institutionId) {
                throw new Error("Department ID is required");
            }

            if (!tenantId) {
                throw new Error("Tenant ID is required");
            }

            // Prepare the data to send to API with correct structure
            const areaData = JSON.stringify({
                areaName: values.areaName,
                institutionDTO: {
                    id: parseInt(institutionId) // Ensure it's a number
                },
                tenantDTO: {
                    id: parseInt(tenantId) // Ensure it's a number
                }
                // Add subTenantDTO if required by your API
                // subTenantDTO: {
                //     id: decodedToken?.subTenantId || 1
                // }
            });

            // Log the data being sent
            console.log("Sending area data:", areaData);

            // Call your API to add the cleaning area
            const response = await AreasApi.CreateArea(areaData);

            // Log the response
            console.log("API Response:", response);

            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Success</span>,
                description: "Cleaning area added successfully",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#b3ffb3",
                    color: "green",
                },
            });

            handleCloseModal();
            getAreas(); // Refresh the list
            PageLoading();
        } catch (error) {
            console.error("Error adding area:", error);

            // Better error message handling
            let errorMessage = "Failed to add cleaning area";

            if (error?.response?.data) {
                // If error has response data
                errorMessage = error.response.data.message || error.response.data.error || errorMessage;
            } else if (error?.message) {
                errorMessage = error.message;
            } else if (typeof error === 'string') {
                errorMessage = error;
            }

            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: errorMessage,
                closeIcon: false,
                duration: 5, // Increased duration to read error
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
        } finally {
            setLoading(false);
        }
    };

    const handleEditArea = async (values) => {
        setLoading(true);
        try {
            // Log the values to see what we're getting from the form
            console.log("Edit form values:", values);
            console.log("Editing area:", editingArea);

            // Ensure we have all required IDs
            const institutionId = values.departmentId;
            const tenantId = decodedToken?.tenantId;

            // Validate required fields
            if (!institutionId) {
                throw new Error("Department ID is required");
            }

            if (!tenantId) {
                throw new Error("Tenant ID is required");
            }

            // Prepare the data to send to API with correct structure
            const areaData = {
                id: editingArea?.id,
                areaName: values.areaName,
                institutionDTO: {
                    id: parseInt(institutionId)
                },
                tenantDTO: {
                    id: parseInt(tenantId)
                }
            };

            // Log the data being sent
            console.log("Updating area data:", areaData);

            // Call your API to update the cleaning area
            const response = await AreasApi.PutArea(editingArea?.id, JSON.stringify(areaData));

            // Log the response
            console.log("API Response:", response);

            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Success</span>,
                description: "Cleaning area updated successfully",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#b3ffb3",
                    color: "green",
                },
            });

            handleCloseModal();
            getAreas(); // Refresh the list
            PageLoading();
        } catch (error) {
            console.error("Error updating area:", error);

            // Better error message handling
            let errorMessage = "Failed to update cleaning area";

            if (error?.response?.data) {
                errorMessage = error.response.data.message || error.response.data.error || errorMessage;
            } else if (error?.message) {
                errorMessage = error.message;
            } else if (typeof error === 'string') {
                errorMessage = error;
            }

            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: errorMessage,
                closeIcon: false,
                duration: 5,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
        } finally {
            setLoading(false);
        }
    };

    const handleFormSubmit = (values) => {
        if (isEditMode) {
            handleEditArea(values);
        } else {
            handleAddArea(values);
        }
    };

    const paginatedData = areas;

    const renderTableRows = () => {
        if (paginatedData.length > 0) {
            return paginatedData.map((item) => (
                <tr key={item?.id} className="text-center">
                    <td style={{ width: "30%" }} className="pt-3">
                        {item?.areaName}
                    </td>
                    <td style={{ width: "30%" }} className="pt-3">
                        {item?.institutionDTO?.institutionName}
                    </td>
                    <td style={{ width: "10%" }}>
                        <div className="d-flex justify-content-center">
                            {/* Edit Button */}
                            <Link
                                to={``}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOpenEditModal(item);
                                }}
                                className={decodedToken?.permissions?.some(
                                    (permission) => permission?.authority === 'EDIT_CLEANING_TRACEABILITY_ITEM'
                                ) ? 'btn btn-primary btn-save table-action icon-center mx-1' : 'd-none'}
                                style={{ marginRight: '8px' }}
                            >
                                <EditOutlined />
                                Edit
                            </Link>
                            
                            {/* Delete Button */}
                            <Popconfirm
                                title="Are you sure ?"
                                description="Do you really want to delete this cleaning area?"
                                okText="Yes"
                                onConfirm={() => handleDeleteArea(item.id)}
                                placement="topRight"
                                className="w-100"
                                cancelText="No"
                            >
                                <Link
                                    to={``}
                                    className={decodedToken?.permissions?.some(
                                        (permission) => permission?.authority === 'DELETE_CLEANING_TRACEABILITY_ITEM'
                                    ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                                >
                                    <DeleteOutlined />
                                    Delete
                                </Link>
                            </Popconfirm>
                        </div>
                    </td>
                </tr>
            ));
        } else {
            return (
                <tr className="text-center EmptyTable">
                    <td colSpan={10} className="text-center ">
                        <EmptyBox />
                        <br />
                        <Button
                            type="primary"
                            onClick={handleOpenAddModal}
                            style={{
                                display: decodedToken?.permissions?.some(
                                    permission => permission?.authority === 'ADD_CLEANING_TRACEABILITY_ITEM'
                                ) ? '' : 'none',
                                height: 'auto',
                                lineHeight: 'normal',
                                alignItems: 'center',
                                padding: '5px 24px',
                            }}
                        >
                            Add cleaning area
                        </Button>
                    </td>
                </tr>
            );
        }
    };


    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <div
                    style={{
                        padding: "20px",
                        paddingBottom: "5px",
                    }}
                >
                    <Form
                        ref={formRef}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass FilterForm"
                        onFinish={handleSubmit}
                    >
                        <>
                            <Collapse>
                                <Panel
                                    header={
                                        <h5 className="mb-0">
                                            <b>Filter</b>
                                        </h5>
                                    }
                                    key="1"
                                >
                                    {filterTraceabilityItem.map((input, filterTraceabilityItemIndex) => (
                                        <div key={filterTraceabilityItemIndex}>
                                            <Row gutter={12} className="pt-2">
                                                <Col span={5}>
                                                    <Form.Item
                                                        name={`title${filterTraceabilityItemIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select"
                                                            placeholder="Filter By"
                                                            value={input.title}
                                                            onChange={(value) =>
                                                                handleChangeTitle(filterTraceabilityItemIndex, value)
                                                            }
                                                            options={[
                                                                {
                                                                    value: "areaName",
                                                                    label: "Area Name",
                                                                },
                                                                {
                                                                    value: "department",
                                                                    label: "Department",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={4}>
                                                    <Form.Item
                                                        name={`type${filterTraceabilityItemIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select type.",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select mb-1"
                                                            placeholder="Condition"
                                                            onChange={(value) =>
                                                                handleChangeAnswertype(
                                                                    filterTraceabilityItemIndex,
                                                                    value
                                                                )
                                                            }
                                                            options={[
                                                                { value: "%", label: "Matches with" },
                                                                {
                                                                    value: "=",
                                                                    label: "Equals to",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={5}>
                                                    <Form.Item
                                                        name={`name${filterTraceabilityItemIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please enter Text.",
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            type="text"
                                                            onChange={(e) =>
                                                                handleChangename(
                                                                    filterTraceabilityItemIndex,
                                                                    e.target.value
                                                                )
                                                            }
                                                            placeholder="Text"
                                                            className="control-input"
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={8}>
                                                    <Form.Item className="text-lable">
                                                        {filterTraceabilityItemIndex == 0 ? (
                                                            <>
                                                                <Row gutter={23} className="mb-3">
                                                                    <Col span={2} className="mx-0">
                                                                        <Form.Item className="text-lable">
                                                                            <PlusCircleTwoTone
                                                                                onClick={handleAddfilterTraceability}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="primary"
                                                                            htmlType="submit"
                                                                            className="btn btn-primary btn-save table-action icon-center "
                                                                        >
                                                                            Filter
                                                                        </Button>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="reset"
                                                                            htmlType="reset"
                                                                            onClick={() => handleClear()}
                                                                            style={{ color: "#0b5ed7" }}
                                                                            className="btn btn-primary btn-back table-action icon-center"
                                                                        >
                                                                            Clear
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {" "}
                                                                <MinusCircleTwoTone
                                                                    onClick={() =>
                                                                        handleRemovefilterTraceability(
                                                                            filterTraceabilityItemIndex
                                                                        )
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </>
                    </Form>
                </div>
                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                {paginatedData.length > 0 && (
                                    <Button
                                        type="primary"
                                        onClick={handleOpenAddModal}
                                        style={{
                                            display: decodedToken?.permissions?.some(
                                                (permission) => permission?.authority === "ADD_CLEANING_TRACEABILITY_ITEM"
                                            )
                                                ? "block"
                                                : "none",
                                            height: "auto",
                                            lineHeight: "normal",
                                            alignItems: "center",
                                            padding: "5px 24px",
                                        }}
                                    >
                                        Add cleaning area
                                    </Button>
                                )}
                            </div>
                            <div>
                                <Form
                                    form={formPaginate}
                                >
                                    <Form.Item
                                        name="paginate"
                                        className="text-lable"
                                        style={{ width: '100px' }}
                                    >
                                        <Select
                                            className="control-Select"
                                            onChange={(value) => {
                                                handlesetPaginateLimit(value)
                                            }}
                                            options={[
                                                { value: 10, label: "10" },
                                                { value: 20, label: "20" },
                                                { value: 30, label: "30" },
                                                { value: 40, label: "40" },
                                                { value: 50, label: "50" },
                                            ]}
                                        />
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                        <table className="table users-table">
                            <thead>
                                <tr>
                                    <th>Cleaning Area Name</th>
                                    <th>Department</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>
                        {paginatedData.length > 0 && PaginatetotalPages > 1 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={PaginatetotalPages}
                            onPageChange={handlePageChange}
                            maxVisiblePages={5}
                            showPageInfo={true}
                            totalItems={totalElements}
                            pageSize={PaginateLimit}
                        />  
                        )}
                    </div>
                </Content>

                {/* <FooterDashboard /> */}
            </Layout>

            {/* Add/Edit Cleaning Area Modal */}
            <Modal
                title={isEditMode ? "Edit Cleaning Area" : "Add Cleaning Area"}
                open={isModalVisible}
                onCancel={handleCloseModal}
                footer={null}
                width={500}
                destroyOnClose
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFormSubmit}
                    initialValues={{ areaName: "" }}
                >
                    <Form.Item
                        label="Department"
                        name="departmentId"
                        rules={[
                            { required: true, message: "Please select a department" }
                        ]}
                    >
                        <Select
                            placeholder="Select Department"
                            showSearch
                            disabled={isEditMode} // Disable department change in edit mode
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {departments.map((dept) => (
                                <Select.Option key={dept.id} value={dept.id}>
                                    {dept?.institutionName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Area Name"
                        name="areaName"
                        rules={[
                            { required: true, message: "Please enter area name" },
                            { min: 2, message: "Area name must be at least 2 characters" },
                            { max: 100, message: "Area name cannot exceed 100 characters" }
                        ]}
                    >
                        <Input
                            placeholder="Enter cleaning area name"
                            autoComplete="off"
                        />
                    </Form.Item>

                    <Form.Item>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <Button
                                style={{ padding: "5px 24px", height: "auto", lineHeight: "normal", alignItems: "center" }}
                                onClick={handleCloseModal}>
                                Cancel
                            </Button>
                            <Button
                                style={{ padding: "5px 24px", height: "auto", lineHeight: "normal", alignItems: "center" }}
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                            >
                                {isEditMode ? "Update Area" : "Add Area"}
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </Layout>
    );
};

export default CleaningTraceabilityAreas;